import React, { FC } from "react";
import { Box, Stack } from "@mui/material";
import styled from "@emotion/styled";
import OnboardingStepper from "@components/Onboarding/OnboardingStepper";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";
import { Outlet, useLocation } from "react-router-dom";
import { isAddPatientFlow } from "@components/Onboarding/onboardingFlow";

const Title = styled.h1`
  font-size: 32px;
  line-height: 48px;
  font-weight: 500;
  color: #171a1fff;

  @media (max-width: ${ScreenSize.md}px) {
    font-size: 24px;
    line-height: 24px;
  }
`;

const OnboardingPageContainer: FC<{ title?: string }> = ({ title }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });
  const isPatientOnlyFlow = isAddPatientFlow(location.search);

  return (
    <Stack width="100%" height="100%" boxSizing="border-box">
      <Stack width="100%" maxWidth="1024px" height="100%" margin="0 auto">
        <Box
          padding={isSmScreen ? "0 8px" : "0 16px"}
          marginBottom={isSmScreen ? "8px" : "24px"}
        >
          <Title>
            {title || t(isPatientOnlyFlow ? "onboarding.addPatientTitle" : "onboarding.title")}
          </Title>
        </Box>

        <Stack
          flexDirection={isSmScreen ? "column" : "row"}
          gap="16px"
          flex="1"
        >
          <Box
            width={isSmScreen ? "100%" : "320px"}
            overflow="auto"
            padding={isSmScreen ? "0 8px" : "0 16px"}
            boxSizing="border-box"
          >
            <OnboardingStepper />
          </Box>
          <Box
            flex="1"
            display="flex"
            flexDirection="column"
            padding={isSmScreen ? "0 8px 16px" : "0 24px 24px"}
          >
            <Outlet />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default OnboardingPageContainer;
